import { render, staticRenderFns } from "./TraceabilityDescContainer.vue?vue&type=template&id=f22a8c4c"
import script from "./TraceabilityDescContainer.vue?vue&type=script&lang=js"
export * from "./TraceabilityDescContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports